import { biaInterfaceTypeOptions } from "@/common/const";
import { eplAccessTechOptions } from "@/common/const/filter-options";
import { contractTermsOptions } from "@/common/const/types/index.const";
import { FormFieldsStrategyType } from "@/common/types";

const eplManualFormStrategy: FormFieldsStrategyType[] = [
  {
    inputType: "text",
    label: "Bandwidth (in Mbps)",
    name: "bandWidth",
    required: true,
    patternMessage: "Value not satisfied range from 0.128 to 10,000",
    pattern:
      /^(?:0\.(?:12[89]|1[3-9]\d|[2-9]\d{1,2})|[1-9]\d{0,3}(?:\.\d{1,3})?|10000(?:\.0{1,3})?)$/,
  },
  {
    inputType: "select",
    label: "Access Technology",
    name: "AccessTechnology",
    required: true,
    defaultValue: eplAccessTechOptions[0].value,
    options: eplAccessTechOptions,
  },
  {
    inputType: "select",
    label: "Interface",
    name: "interface",
    required: true,
    defaultValue: biaInterfaceTypeOptions[0].value,
    options: biaInterfaceTypeOptions,
  },
  {
    inputType: "select",
    label: "Contract Term",
    name: "contractTerm",
    required: true,
    defaultValue: "1",
    options: [...contractTermsOptions],
  },
];
export default eplManualFormStrategy;
